// Port of api/fuel/app/classes/insights/hindex/ratings.php
import Segment from 'offline/insights/segment'
import Util from 'offline/util'
import Constants from 'offline/constants'

export default Segment.extend({
    name: 'ratings',
    priority: 1,
    default_: true,
    requires: ['init'],
    insight: false,
    detail: [],
    types: [Constants.TYPE_USER, Constants.TYPE_GROUP, Constants.TYPE_BUDDIES],
    run: function(type, owner, userIndex, detail, filter, vars) {

        if (!this._data.track || !this._data.track.get_hindex()) return {}
        if (!owner.get_count_ratings || !owner.get_count_ratings()) return {}

        var collectionIndex = this._data.current.get_index_level()

        if (detail) {

            var games = []

            var results = Util.query(
                'SELECT r.game_id AS g, r.rating_value AS r' +
                ' FROM rating r, game g' +
                ' WHERE r.game_id = g.game_id' +
                ' AND r.user_id IN (' + Util.in(userIndex) + ')' +
                ' AND CAST(r.rating_value AS INTEGER) = ' + vars.rating +
                ' AND r.game_id IN (' + Util.in(collectionIndex) + ')' +
                ' ORDER BY g.game_sortname ASC'
            )

            for (var i = 0; i < results.length; i++) {
                this._references.games.push(results[i].g)
                games.push({
                    id: parseInt(results[i].g, 10),
                    rating: parseFloat(results[i].r)
                })
            }

            return {
                rating: vars.rating,
                games: games
            }

        } else {

            var sqlResults = Util.query(
                'SELECT group_concat(DISTINCT r.game_id) as games,' +
                ' CAST(r.rating_value AS INTEGER) AS rating,' +
                ' COUNT(r.rating_id) AS ratings' +
                ' FROM rating r' +
                ' WHERE r.user_id IN (' + Util.in(userIndex) + ')' +
                ' AND r.game_id IN (' + Util.in(collectionIndex) + ')' +
                ' GROUP BY CAST(r.rating_value AS INTEGER)'
            )

            var ratingCounts = {}
            for (var j = 0; j < sqlResults.length; j++) {
                var result = sqlResults[j]
                var featured = result.games ? result.games.split(',') : []
                var randomFeatured = featured.sort(function(a, b) { return parseInt(a, 10) - parseInt(b, 10) })[0]

                ratingCounts[result.rating] = {
                    value: String(result.ratings),
                    game: parseInt(randomFeatured, 10)
                }
            }

            return {
                ratings: ratingCounts,
                // Mirrors PHP array_sum($ratingCounts) returning 0 for nested arrays.
                totalRatings: 0
            }

        }

    }
})
